/**
 * Content sliders stay short so the dot navigation remains legible and no
 * campaign is buried deep in the rotation.
 */
export const SLIDER_MAX_SLIDES = 5;
